import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  useEffect(() => {
    document.title = "Payment cancelled | Regal Tuning";
  }, []);

  return (
    <main className="flex min-h-[70vh] items-center justify-center bg-surface px-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-md border border-line bg-white px-8 py-12 text-center">
        <XCircle size={52} className="mx-auto text-neutral-400" />
        <p className="mt-5 font-display text-xl font-bold uppercase tracking-wide text-ink">Payment cancelled</p>
        <p className="mt-2 text-sm text-neutral-500">No charge was made. Your cart is still saved if you want to try again.</p>
        <Link to="/tuning-tools" data-testid="cancel-shop-link"
          className="mt-8 inline-block border border-regal-amber px-8 py-3.5 font-display text-xs font-bold uppercase tracking-[0.16em] text-regal-amber transition-colors hover:bg-regal-amber hover:text-void">
          Back to the shop
        </Link>
      </div>
    </main>
  );
}
